// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueLocalStorage from 'vue-localstorage'
import VeeValidate from 'vee-validate'
import VueResource from 'vue-resource'
import VuejsDialog from 'vuejs-dialog'
import VCalendar from 'v-calendar'
import Notifications from 'vue-notification'
import 'v-calendar/lib/v-calendar.min.css'
import VueTagsInput from '@johmun/vue-tags-input';
import { MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns';
import Paginate from 'vuejs-paginate';
import VueQRCodeComponent from 'vue-qrcode-component'
import Multiselect from 'vue-multiselect';
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import { CheckBox, ChangeEventArgs } from '@syncfusion/ej2-buttons';
import VueSimpleAlert from "vue-simple-alert";
import VJstree from 'vue-jstree'
import VueCryptojs from 'vue-cryptojs'
import vSelect from "vue-select";
import * as VueGoogleMaps from 'vue2-google-maps'; 
import '../node_modules/nprogress/nprogress.css' 
Vue.component("v-select", vSelect);


Vue.use(VueCryptojs)
Vue.use(VJstree)  
  
// import { TreeViewPlugin } from "@syncfusion/ej2-vue-navigations";

// Vue.use(TreeViewPlugin);
Vue.config.silent = true;
// todo
// cssVars()
Vue.use(MultiSelectPlugin);
Vue.use(VueLocalStorage)
Vue.use(BootstrapVue)
Vue.component('paginate', Paginate)
Vue.use(Notifications)
Vue.use(VueSidebarMenu)
Vue.component('qr-code', VueQRCodeComponent)
 Vue.component('multiselect', Multiselect)
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
  // This is the default
  // inject: true,
  // // Important to name this something other than 'fields'
  // fieldsBagName: 'veeFields',
  // // This is not required but avoids possible naming conflicts
  // errorBagName: 'veeErrors'
});
Vue.use(VueResource)
Vue.use(VuejsDialog)
Vue.use(VCalendar)
Vue.use(VueTagsInput);
Vue.use(MultiSelectPlugin);
MultiSelect.Inject(CheckBoxSelection);
Vue.use(VueSimpleAlert);
Vue.use(VueGoogleMaps, {   load: {key: 'AIzaSyBpj7ZtTQGdQnBzTVDFPn5rjHSLoSwx-GI',
 // Replace with your actual API key AIzaSyBpj7ZtTQGdQnBzTVDFPn5rjHSLoSwx-GI   AIzaSyBH5eKrPFXp5mfo35rQ2R1tMgUTuXU2RSI.
libraries: 'places', // You can add more libraries if needed 
 }, });

//  Vue.use(NProgress)



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
